import { BoxGeometry, Group, Mesh, MeshBasicMaterial, Scene } from 'three';
import { Area } from './area';

export const illuminationBoxesForAreas = (areas: Area[], scene: Scene): Group => {
  const group: Group = new Group();
  group.name = 'illuminationBoxes';
  const lighterMaterial: MeshBasicMaterial = new MeshBasicMaterial({
    color: 0x6db6f2,
  });
  const darkerMaterial: MeshBasicMaterial = new MeshBasicMaterial({
    color: 0x5ea0d6,
  });
  areas.forEach((a: Area): void => {
    const illuminationGroup: Group = new Group();
    illuminationGroup.name = `${a.x},${a.y}${a.z},illuminationBox`;
    const areaBox: BoxGeometry = new BoxGeometry(a.width, 1, a.length);
    let material: MeshBasicMaterial;
    if (a.y === 0) {
      material = lighterMaterial
    } else {
      material = darkerMaterial
    }
    const planeMesh = new Mesh<any>(areaBox, material);
    planeMesh.position.set(a.x, a.y, a.z);
    planeMesh.translateX(a.width / 2);
    planeMesh.translateY(a.y * 0.001);
    planeMesh.translateZ(a.length / 2);
    illuminationGroup.add(planeMesh);
    group.add(illuminationGroup);
  });

  scene.add(group);
  return group;
};

export default { illuminationBoxesForAreas };
